import axios from 'axios';
import {getMsApiGatewayHostname} from '@digital-advice/ms-core-sdk';

let MS_BASE = window.location.origin;

const BASE_FOLDER = process.env.VUE_APP_BASE_FOLDER;
const PROXY_ROOT = 'ms';
const ADMIN_TOKEN_ROUTE = 'at';

const MS_GATEWAY_PROXY = getMsApiGatewayHostname();
const MS_GATEWAY_ADVISOR_KEY = process.env.VUE_APP_MS_API_GATEWAY_KEY;

if (BASE_FOLDER) {
  MS_BASE = `${MS_BASE}/${BASE_FOLDER}/${PROXY_ROOT}`;
}

/**
 * Needs refactor
 */
export default class Service {
  static get MS_BASE() {
    return MS_BASE;
  }

  static get ADMIN_TOKEN_ROUTE() {
    return ADMIN_TOKEN_ROUTE;
  }

  static get MS_GATEWAY_PROXY() {
    return MS_GATEWAY_PROXY;
  }

  static get MS_GATEWAY_ADVISOR_KEY() {
    return MS_GATEWAY_ADVISOR_KEY;
  }

  static get MS_SERVICE_TOKEN_BASE() {
    return `${MS_GATEWAY_PROXY}/serviceToken`;
  }

  /**
   * Used to call service which requires paging
   * @param {String} url Url to call service
   * @param {Number} limit
   * @param {Number} offset
   */
  static getPaging(url, limit = 0, offset = 0) {
    let pagingUrl = url;

    if (limit === 0 && offset === 0) {
      return axios.get(pagingUrl);
    }

    pagingUrl = url.includes('?') ? `${url}&` : `${url}?`;

    return axios.get(`${pagingUrl}limit=${limit}&offset=${offset}`);
  }

  static getParams(obj, keys) {
    const retArr = {};

    if (obj && typeof obj === 'object' && Array.isArray(keys)) {
      keys.forEach((key) => {
        if (typeof obj[key] !== 'undefined') {
          retArr[key] = obj[key];
        }
      });
    }

    return retArr;
  }

  /**
   *
   * @param {Object} objectWithValues
   */
  static getSetFieldsAsNull(objectWithValues, keysToCheck = false) {
    let arrSetFieldsAsNull = [];
    let strSetFieldsAsNull = '';

    arrSetFieldsAsNull = Object.keys(objectWithValues).filter((key) => {
      if (keysToCheck && !keysToCheck.includes(key)) {
        return false;
      }

      const val = objectWithValues[key];

      return val === 0 || val === '' || !val;
    });

    if (arrSetFieldsAsNull.length > 0) {
      strSetFieldsAsNull += `setFieldsAsNull=${arrSetFieldsAsNull.join(',')}`;
    }

    return strSetFieldsAsNull;
  }
}
